export class ValidationError extends Error {
    constructor(validationErrors, ...params) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValidationError);
        }
        this.name = 'validation_error';
        this.validationErrors = validationErrors;
    }
}
//# sourceMappingURL=customHooks.js.map